/** @type {import('../schema').ProcessDefinition} */
const incidencias = {
  id: "incidencias",
  name: "Reclamos / incidencias",
  category: "operaciones",
  outcome: "Resolver problemas reportados por residentes con seguimiento y SLA.",
  trigger:
    "El residente reporta (incluida alta por voz transcrita y analizada por IA desde el botón flotante); o el admin la carga.",
  actors: ["Residente", "Empleado", "Bot Habi", "Administrador", "Proveedor"],
  status: "COMPLETO",
  description:
    "Ciclo completo de una incidencia: alta por el residente (texto o voz con extracción IA de tema/prioridad) o por un empleado desde su panel, asignación, seguimiento con SLA por prioridad, resolución y cierre. Puede derivar en una orden de trabajo a un proveedor.",
  lanes: [
    { id: "res", actor: "Residente" },
    { id: "emp", actor: "Empleado" },
    { id: "bot", actor: "Bot Habi" },
    { id: "admin", actor: "Administrador" },
    { id: "prov", actor: "Proveedor" },
  ],
  steps: [
    { id: "s1", laneId: "res", type: "start", label: "Reporta la incidencia (texto o voz)", description: "Desde el botón flotante; puede grabar audio.", evidence: "src/components/FloatingActionButton.jsx" },
    { id: "s0", laneId: "emp", type: "start", label: "Empleado reporta una novedad", description: "Un empleado reporta desde su panel (incidents con reporterType: employee).", evidence: "src/screens/employee/IncidentesEmployee.jsx:82" },
    { id: "s2", laneId: "bot", type: "task", label: "Transcribe y extrae tema + prioridad", description: "La IA detecta tema (sanitario, ascensor, etc.) y prioridad." },
    { id: "s3", laneId: "admin", type: "task", label: "Recibe (estado: Reportada)", description: "Queda registrada con título, descripción, ubicación, tema, prioridad y adjuntos. Asigna SLA por prioridad.", evidence: "src/screens/admin/IncidenciasEdificio.jsx:49" },
    { id: "s4", laneId: "admin", type: "decision", label: "¿Requiere proveedor?" },
    { id: "s5", laneId: "admin", type: "handoff", label: "Coordina orden de trabajo", description: "Deriva la reparación a un proveedor del edificio." },
    { id: "s6", laneId: "prov", type: "task", label: "Ejecuta el trabajo" },
    { id: "s7", laneId: "admin", type: "task", label: "Asigna y atiende (estado: En Proceso)", description: "Valida, asigna responsable y responde; registra historial de acciones." },
    { id: "s8", laneId: "admin", type: "wait", label: "Seguimiento dentro del SLA", description: "Si una crítica supera el SLA, se destaca/escala.", sla: "alta 48h · media 72h · baja 7 días" },
    { id: "s9", laneId: "admin", type: "notification", label: "Marca Resuelta y notifica", description: "Notifica al residente la resolución (in-app / WhatsApp)." },
    { id: "s10", laneId: "admin", type: "end", label: "Cierra (estado: Cerrada)", description: "Cierre manual o por inactividad." },
  ],
  transitions: [
    { from: "s1", to: "s2" },
    { from: "s0", to: "s3", label: "alta directa" },
    { from: "s2", to: "s3" },
    { from: "s3", to: "s4" },
    { from: "s4", to: "s5", label: "sí" },
    { from: "s4", to: "s7", label: "no" },
    { from: "s5", to: "s6" },
    { from: "s6", to: "s7" },
    { from: "s7", to: "s8" },
    { from: "s8", to: "s9" },
    { from: "s9", to: "s10" },
  ],
};

export default incidencias;
